if (!customElements.get('product-slider-thumbnails')) {
  /**
   *  @class
   *  @function ProductSliderThumbnails
   */
  class ProductSliderThumbnails extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();

      // Delegated click on image area opens lightbox (desktop stacked layout only).
      // Uses delegation so it survives Flickity destroy / DOM reorder.
      // Handles clicks anywhere in the image container, including the zoom <a> tag.
      if (!this._imageClickBound) {
        this._imageClickBound = true;
        this.addEventListener('click', (e) => {
          // Only on desktop (Flickity destroyed = stacked layout)
          if (Flickity.data(this)) return;
          // Find the closest image media container
          const media = e.target.closest('.product-single__media-image');
          if (!media) return;
          const link = media.querySelector('.product-single__media-zoom');
          if (!link) return;
          e.preventDefault();
          this.zoomClick(e, link);
        });
      }
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item, idx) => {
        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = idx;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: true,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => {
          // On desktop (Flickity destroyed), the delegated handler on the slider
          // handles all image + zoom clicks. Only use per-link handlers on mobile.
          if (!Flickity.data(this)) return;
          this.zoomClick(e, link);
        });
      }));
    }
    zoomClick(e, link) {
      // Ensure pswp element and options are ready (setEventListeners may not have run)
      if (!this.pswpElement) {
        this.pswpElement = document.querySelectorAll('.pswp')[0];
      }
      if (!this.pswpOptions) {
        this.pswpOptions = {
          maxSpreadZoom: 2, loop: false, allowPanToNext: false,
          closeOnScroll: false, showHideOpacity: true, arrowKeys: true,
          history: false, captionEl: false, fullscreenEl: false,
          zoomEl: false, shareEl: false, counterEl: true, arrowEl: true,
          preloaderEl: true
        };
      }
      e.preventDefault();
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined' && this.pswpElement) {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.listen('destroy', () => {
          this.pswpElement.classList.remove(
            'pswp--open', 'pswp--animate_opacity', 'pswp--notouch',
            'pswp--css_animation', 'pswp--svg', 'pswp--animated-in',
            'pswp--has_mouse'
          );
          this.pswpElement.removeAttribute('style');
          // Ensure cleanup survives any post-destroy style reapplication by PhotoSwipe
          const el = this.pswpElement;
          setTimeout(() => {
            el.classList.remove(
              'pswp--open', 'pswp--animate_opacity', 'pswp--notouch',
              'pswp--css_animation', 'pswp--svg', 'pswp--animated-in',
              'pswp--has_mouse'
            );
            el.removeAttribute('style');
          }, 400);
        });
        pswp.init();
      }
    }
  }
  customElements.define('product-slider-thumbnails', ProductSliderThumbnails);
}

/* === DF GALLERY REPAIR 2026-09-30 (begin) === */
/* Why: product-thumbnails.js is deferred BEFORE vendor.min.js, so Flickity is undefined
   when connectedCallback runs. It throws at `new Flickity(...)` and never binds the
   delegated lightbox handler, leaving mobile with 1 visible image and image clicks
   navigating to the raw .jpg. This block is idempotent and a no-op once the load order
   is fixed upstream. */
(function () {
  if (window.__dfGalleryRepair) return;
  window.__dfGalleryRepair = true;

  var style = document.createElement('style');
  style.textContent =
    'product-slider-thumbnails.df-gallery-fallback .product-images__slide{display:block!important;margin-bottom:12px}' +
    'product-slider-thumbnails.df-gallery-fallback .flickity-viewport{height:auto!important}';
  (document.head || document.documentElement).appendChild(style);

  function galleries() {
    return Array.prototype.slice.call(document.querySelectorAll('product-slider-thumbnails'));
  }

  function bindZoom(el) {
    if (el._imageClickBound) return;
    el._imageClickBound = true;
    el.addEventListener('click', function (e) {
      // When Flickity is live the per-link handlers own the click; don't double-open.
      if (typeof Flickity !== 'undefined' && Flickity.data(el)) return;
      var media = e.target && e.target.closest && e.target.closest('.product-single__media-image');
      if (!media) return;
      var link = media.querySelector('.product-single__media-zoom');
      if (!link || typeof el.zoomClick !== 'function') return;
      e.preventDefault();
      el.zoomClick(e, link);
    });
  }

  // True only where the FOUC guard is actually hiding slides (mobile). On desktop the
  // stacked layout shows every slide, so Flickity is not wanted there.
  function slidesHidden(el) {
    var s = el.querySelectorAll('.product-images__slide');
    if (s.length < 2) return false;
    return window.getComputedStyle(s[1]).display === 'none';
  }

  function repair(el) {
    bindZoom(el);
    if (el.flkty || el.classList.contains('flickity-enabled')) return true;
    if (!slidesHidden(el)) return true;
    if (typeof Flickity === 'undefined') return false;
    try {
      el.setOptions();
      el.init();
      return true;
    } catch (err) {
      console.warn('[df] gallery init failed', err);
      return false;
    }
  }

  var tries = 0;
  (function tick() {
    var pending = false;
    galleries().forEach(function (el) { if (!repair(el)) pending = true; });
    if (pending && ++tries < 50) { setTimeout(tick, 100); return; }
    galleries().forEach(function (el) {
      if (!el.classList.contains('flickity-enabled') && slidesHidden(el)) {
        el.classList.add('df-gallery-fallback');
        console.warn('[df] gallery fell back to stacked images');
      }
    });
  })();
})();
/* === DF GALLERY REPAIR 2026-09-30 (end) === */
